import React from 'react'
import { Link } from 'react-router-dom'
import useRemoteModule from '../../hooks/useRemoteModule'
import { mapPackageItem } from '../../services/contentApi'

const fallbackPlans = [
    {
        id: 1,
        title: 'Economy Plan',
        offerTag: 'Budget',
        icon: '/assets/img/icon/price_1_1.svg',
        price: 'PKR 25,000',
        durationLabel: '/Per Person',
        description: 'Best for budget-conscious travelers who want to explore northern Pakistan comfortably.',
        features: [
            '3-4 Days Tour',
            'Standard Hotel Stay',
            'Breakfast Included',
            'Shared Vehicle (Coaster)',
            'Professional Tour Guide',
            'Entry Tickets Included',
            'Basic First Aid Support'
        ],
        whatsappText: 'Assalam o Alaikum! I am interested in the Economy Tour Plan. Please share details.',
        isPopular: false
    },
    {
        id: 2,
        title: 'Deluxe Plan',
        offerTag: 'Popular',
        icon: '/assets/img/icon/price_1_2.svg',
        price: 'PKR 45,000',
        durationLabel: '/Per Person',
        description: 'Our most popular choice - perfect for families, couples, and group travelers seeking comfort and adventure.',
        features: [
            '5 Days / 4 Nights Tour',
            'Deluxe Hotel Stay',
            'Breakfast & Dinner',
            'Private Vehicle (Prado/TZ)',
            'Professional Tour Guide',
            'All Entry Tickets',
            'BBQ & Bonfire Evening'
        ],
        whatsappText: 'Assalam o Alaikum! I am interested in the Deluxe Tour Plan. Please share details.',
        isPopular: true
    },
    {
        id: 3,
        title: 'Luxury Plan',
        offerTag: 'Premium',
        icon: '/assets/img/icon/price_1_3.svg',
        price: 'PKR 85,000',
        durationLabel: '/Per Person',
        description: 'An all-inclusive premium experience - ideal for honeymoon couples and travelers who want nothing but the best.',
        features: [
            '7 Days / 6 Nights Tour',
            '5-Star Resort & Hotel Stay',
            'All Meals Included',
            'Private Luxury Prado',
            'Senior Tour Guide',
            'All Entry Tickets & Permits',
            'Airport/Station Transfers'
        ],
        whatsappText: 'Assalam o Alaikum! I am interested in the Luxury Tour Plan. Please share details.',
        isPopular: false
    }
]

function PricingPlan({className}) {
    const plans = useRemoteModule('packages', mapPackageItem, fallbackPlans)

    return (
        <section className={`position-relative ${className}`}>
            <div className="container shape-mockup-wrap">
                <div className="title-area text-center">
                    <span className="sub-title">Tour Packages</span>
                    <h2 className="sec-title">Affordable Tour Plans</h2>
                </div>
                <div className="row gy-4 justify-content-center">
                    {plans.map((plan) => (
                        <div key={plan.id} className="col-xl-4 col-md-6">
                            <div className={`price-card ${plan.isPopular ? 'active' : ''}`}>
                                <div className="offer-tag">{plan.offerTag}</div>
                                <div className="price-card_wrapp">
                                    <div className="price-card_icon">
                                        <img src={plan.icon} alt={plan.title} />
                                    </div>
                                    <h3 className="box-title">{plan.title}</h3>
                                </div>
                                <div className="price-card_content">
                                    <h4 className="price-card_price">
                                        {plan.price}<span className="duration">{plan.durationLabel}</span>
                                    </h4>
                                    <p className="price-card_text">{plan.description}</p>
                                    <div className="checklist">
                                        <ul>
                                            {plan.features.map((feature, featureIndex) => (
                                                <li key={featureIndex}>{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="price-btn">
                                    <Link
                                        to={`https://wa.me/03479020168?text=${encodeURIComponent(plan.whatsappText)}`}
                                        className="th-btn style3 w-100"
                                    >
                                        Book Now
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div
                    className="shape-mockup movingX d-none d-xxl-block"
                    style={{ bottom: "0%", right: "-18%" }}
                >
                    <img
                        className="gmovingX"
                        src="assets/img/normal/about-slide-img.png"
                        alt="shape"
                    />
                </div>
                <div
                    className="shape-mockup d-none d-xl-block"
                    style={{ bottom: "-13%", left: "-16%" }}
                >
                    <img src="assets/img/shape/shape_6.png" alt="shape" />
                </div>
                <div
                    className="shape-mockup jump d-none d-xl-block"
                    style={{ top: "15%", left: "-10%" }}
                >
                    <img src="assets/img/shape/shape_2_2.png" alt="shape" />
                </div>
            </div>
        </section>

    )
}

export default PricingPlan

